const createAvatarJson = (data: {
  avatarFile?: any;
  avatarLink?: string;
}, uid: number) => {
  const json: {
    data: {
      entity: string;
      entity_id: number;
      url?: string;
    };
  } = { data: { entity: 'sc_avatar', entity_id: uid } };

  if (!data.avatarFile && !data.avatarLink) {
    return null;
  } if (!data.avatarFile && data.avatarLink) {
    json.data.url = data.avatarLink;
  }

  return JSON.stringify(json);
};

export default {
  createAvatarJson,
};
